import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from '../../../contexts/translation';
import { Asset } from '../../../types/app/asset.types';
import { DateTimeIntegerProcess } from '../../../types/app/dataProcess';
import {
  PerformanceComment,
  PerformanceCommentCategory,
  PerformanceCommentCreateRequest,
} from '../../../types/app/performanceComment.types';
import { dateTimeShowFormat, hoursMinutesShowFormat } from '../../../types/core/date.types';

interface Props {
  onSubmit: SubmitHandler<PerformanceCommentCreateRequest>;
  commentCategoryList: PerformanceCommentCategory[];
  selectedCategory?: string;
  setSelectedCategory: any;
  setOpen: any;
}

export function PerformanceCommentForm({
  onSubmit,
  commentCategoryList,
  selectedCategory,
  setSelectedCategory,
  setOpen,
}: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<PerformanceComment>();

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id="demo-simple-select-label">
                {t('page.dashboard.performance-comment.modal-input-category')}
              </InputLabel>
              <Select
                label={t('page.dashboard.performance-comment.modal-input-category')}
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <MenuItem value="">{t('page.dashboard.performance-comment.no-category')}</MenuItem>
                {commentCategoryList.map((category: PerformanceCommentCategory, index: number) => (
                  <MenuItem value={category.name} key={index}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t('page.dashboard.performance-comment.modal-input-qty')}
              {...register('qty')}
              error={Boolean(errors.qty)}
              helperText={errors.qty?.message}
              type={'number'}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t('page.dashboard.performance-comment.modal-input-comment')}
              {...register('comment')}
              error={Boolean(errors.comment)}
              helperText={errors.comment?.message}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item marginBottom={3}>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={() => setOpen(false)}>
                {t('general.action-buttons.back')}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!watch('comment') && !watch('qty') && !selectedCategory}
              >
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
